/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'proxy-config-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitle = `${prefix}.modalTitle`;
export const proxyLabel = `${prefix}.proxyLabel`;
export const proxyError = `${prefix}.proxyError`;

export const ENGLISH = {
    [modalTitle]: 'Edit Proxy',
    [proxyLabel]: 'Proxy',
    [proxyError]: 'An error occurred during updating the proxy',
};
